import type { admin } from '@repletoryreach/sdk-api';

export type Delivery = admin.AdminDelivery;

export type DeliveryOutcome = 'success' | 'redirect' | 'blocked' | 'failed' | 'pending';

/**
 * What actually happened to a delivery attempt.
 *
 * The page used to classify purely on `http_status`, which is null for a
 * delivery the SSRF guard refused. A blocked attempt therefore landed in
 * Pending: the Failed count under-reported every refusal, and the Pending
 * count mixed genuinely in-flight attempts with ones that will never resolve.
 * `blocked_reason` is on the same row and settles it, so it is checked first.
 */
export function outcomeOf(d: Delivery): DeliveryOutcome {
  if (d.blocked_reason) return 'blocked';
  const s = d.http_status;
  if (s == null) return 'pending';
  if (s >= 200 && s < 300) return 'success';
  if (s >= 300 && s < 400) return 'redirect';
  return 'failed';
}

/** Palette name per outcome, resolved through the theme by `Badge`. */
export const OUTCOME_COLOR: Record<DeliveryOutcome, string> = {
  success: 'green',
  redirect: 'orange',
  blocked: 'orange',
  failed: 'red',
  pending: 'gray'
};

export const OUTCOME_LABEL_KEY: Record<DeliveryOutcome, string> = {
  success: 'webhooks.deliveries.kpi.success',
  redirect: 'webhooks.deliveries.filters.statusClass.redirect',
  blocked: 'webhooks.deliveries.blocked',
  failed: 'status.failed',
  pending: 'status.pending'
};
